export var InspectionItemType;
(function (InspectionItemType) {
    InspectionItemType["Volume"] = "volume";
    InspectionItemType["PlaneToPlaneDistance"] = "plane_to_plane_distance";
    InspectionItemType["PlaneToCylindersDistance"] = "plane_to_cylinders_distance";
    InspectionItemType["Grid"] = "grid";
    InspectionItemType["PolygonLength1"] = "polygon_length_1";
    InspectionItemType["PolygonLength2"] = "polygon_length_2";
    InspectionItemType["PolygonPerimeter"] = "polygon_perimeter";
    InspectionItemType["PolygonArea"] = "polygon_area";
    InspectionItemType["LengthWithDistanceTool"] = "length_with_distance_tool";
    InspectionItemType["EdgeLength"] = "edge_length";
    InspectionItemType["PolylineLength"] = "polyline_length";
    InspectionItemType["PolylineWidth"] = "polyline_width";
})(InspectionItemType || (InspectionItemType = {}));
